import React, { useState,useEffect } from 'react';
import { Tabs, Dropdown, Menu, Modal, Form, Input, Button, Select   } from 'antd';
import OverviewDashboard from '../../Components/OverviewDasboard';
import DashboardImg from './../../Assets/images/dashboard.svg';
import FTImg from './../../Assets/images/ft.svg';
import AddImg from './../../Assets/images/add.svg';
import GymImg from './../../Assets/images/gym.svg';
import InfoImg from './../../Assets/images/info.svg';
import OfficeImg from './../../Assets/images/office.svg';
import { useLocation } from 'react-router-dom';
import UniqueAreaDashboard from '../../Components/UniqueAreaDashboard';
import {  Drawer } from 'antd';
import PharmacyImg from '../../Assets/images/pharmacy.svg'
import discountStoreImg from '../../Assets/images/discountstore.svg'



const Dashboard = () => {
  const [activeKey, setActiveKey] = useState('1'); // State to track the active tab
  const [dataForSpaces,setDataForSpaces] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [open, setOpen] = useState(false);

  const location = useLocation();
  const selectedValues = location.state?.selectedValues || [];
  const parkingDemandData = location.state?.parkingDemandData || [];

  useEffect(() => {
    setDataForSpaces(parkingDemandData);
  }, [parkingDemandData]);

  // console.log("dataForSpaces::",dataForSpaces);
  


  
  
  // console.log("graphDemandResponse For Tabs in Dashboard",parkingDemandData);

  // console.log("Selected Value For Tabs in Dashboard",selectedValues);

  // Helper function to get the correct image for each land use type
  const getImageForType = (type) => {
    switch (type) {
      case 'Office': return OfficeImg;
      case 'Gym': return GymImg;
      case 'Film Theater': return FTImg;
      case 'Pharmacy':return PharmacyImg;
      case 'Discount Stores/Superstores':return discountStoreImg;
      default: return DashboardImg; // Default image or you can handle each type specifically
    }
  };
  



  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChange = (key) => {
    setActiveKey(key); // Update the active tab
    // console.log(key);
  };

  const items = [
    {
      key: '1',
      label: (
        <span>
          <img
            src={DashboardImg}
            alt="Overview"
            style={{
              width: 20,
              marginRight: 8,
              filter: activeKey === '1' ? 'none' : 'invert(1)', // White when active, black when inactive
            }}
          />
          Overview
        </span>
      ),
      children: <OverviewDashboard />,
    },
   
  ];

  // Generate tabs based on the API response
  dataForSpaces.forEach((item, index) => {
    items.push({
      key: item.land_use_type,
      // key: item.description,
      label: (
        <span>
          <img
            src={DashboardImg} // Function to get image based on type
            alt={item.land_use_type}
            style={{
              width: 20,
              marginRight: 8,
              filter: activeKey === item.land_use_type ? 'none' : 'invert(1)',
              // filter: activeKey === item.description ? 'none' : 'invert(1)',
            }}
          />
          {/* {item.land_use_type} */}
          {item.land_use_type.replace(/\s*Typical$/, '')}
        </span>
      ),
      children: <UniqueAreaDashboard parkingDemandData={item} />, // Pass each item's data as prop to UniqueAreaDashboard
    });
  });

  console.log("Top Tabs id::",items);
  

  const handleMenuClick = (e) => {
    setSelectedMenuItem(e.key);
    setIsModalVisible(true); // Open the modal
  };
  const handleOk = () => {
    setIsModalVisible(false); // Close the modal
  };
  
  const handleCancel = () => {
    setIsModalVisible(false); // Close the modal
  };
  const dropdownMenu = (
    <Menu onClick={handleMenuClick}>
        <Menu.Item key="1">Family Restaurant</Menu.Item>
        <Menu.Item key="2">Fast Casual/Fast Food</Menu.Item>
        <Menu.Item key="3">Bar/Lounge/Night Club</Menu.Item>
        <Menu.Item key="4">Specialty Movie Theatre</Menu.Item>
        <Menu.Item key="5">Amusement Park/Water Park</Menu.Item>
        <Menu.Item key="6">Live Theater</Menu.Item>
        <Menu.Item key="7">Public Park/Destination Open Space</Menu.Item>
    </Menu>
);
const onChangesFilter = (value, option) => {
  // console.log("Selected:", value);
};

const onChanges = (value, option) => {
  // console.log("Selected value:", value);
};
const onSearch = (searchTerm) => {
  // console.log("Search term:", searchTerm);
};
const renderModalContent = () => {
  return (
      <Form layout="vertical">
          <Form.Item
              label="Land Usage Type"
              name="type"
              rules={[{ required: true, message: 'Please enter Land Usage Type' }]}
          >
              <Select
                showSearch
                placeholder="Select a person"
                optionFilterProp="label"
                onChange={onChanges}
                onSearch={onSearch}
                options={[
                  {
                    value: '>300',
                    label: '>300',
                  },
                  {
                    value: '>500',
                    label: '>500',
                  },
                  {
                    value: '>800',
                    label: '>800',
                  },
                ]}
              />
          </Form.Item>
          <Form.Item
              label="Land usage"
              name="usage"
              rules={[
                  { required: true, message: 'Please enter Land usage' },
              ]}
          >
              <Input placeholder="Please enter Land Usage" />
          </Form.Item>
          <Form.Item
              label="Captive Ratio"
              name="captive"
          >
              <Input placeholder="" />
          </Form.Item>
          <Form.Item
              label="Driving Adjustment"
              name="driving"
          >
              <Input placeholder="" />
          </Form.Item>
          <Form.Item>
              <Button type="primary" htmlType="submit">
                  Submit
              </Button>
          </Form.Item>
      </Form>
  );
};
  return (
    <div className="w-100">
      <div className="d-flex align-items-center">
      <Tabs
            defaultActiveKey="1"
            activeKey={activeKey}
            items={items}
            onChange={onChange}
            type="card"
    //         tabBarExtraContent={
    //           <div className="d-flex align-items-center">
    //             <div>
    //                 <a onClick={showDrawer}  style={{    display: 'flex',
    // alignItems: 'baseline', padding: '8px 23px', borderRadius: '20px', background: 'transparent', border: '1px solid #DDDEDF', marginLeft: '55px', color: '#000000', fontSize: '16px' }}>
    //                     <img src={AddImg} alt="" className="me-2" /> <span>Add Space </span> 
    //                 </a>
    //             </div>
               
    //             </div>
    //         }
        />
      </div>
      <Drawer title="Add Space" onClose={onClose} open={open} width={620}>
        <div className="w-100 d-flex align-items-center info-msg mb-4">
            <img src={InfoImg} className="" style={{width: '20px'}} />
          <p className="mb-0 ms-4">Please enter the details </p>
        </div>
        <div className="drawer-style">
      <Form layout="vertical">
      <Form.Item
              label=""
              name="filterType"
              rules={[{ required: true, message: 'Please enter' }]}
          >
              <Select
                showSearch
                placeholder="Select a filter type"
                optionFilterProp="label"
                onChange={onChangesFilter}
                onSearch={onSearch}
                options={[
                  {
                    value: 'Office',
                    label: 'Office',
                  },
                  {
                    value: 'Gym',
                    label: 'Gym',
                  },
                  {
                    value: 'Retail',
                    label: 'Retail',
                  },
                ]}
              />
          </Form.Item>
          <Form.Item
              label="Land Usage Type"
              name="landUsageType"
              rules={[{ required: true, message: 'Please enter Land Usage Type' }]}
          >
              <Select
                showSearch
                placeholder="Select a land usage type"
                optionFilterProp="label"
                onChange={onChanges}
                onSearch={onSearch}
                options={[
                  {
                    value: '>300',
                    label: '>300',
                  },
                  {
                    value: '>500',
                    label: '>500',
                  },
                  {
                    value: '>800',
                    label: '>800',
                  },
                ]}
              />
          </Form.Item>
          <Form.Item
              label="Land usage"
              name="usage"
              rules={[
                  { required: true, message: 'Please enter Land usage' },
              ]}
          >
              <Input placeholder="Please enter Land Usage" />
          </Form.Item>
          <Form.Item
              label="Captive Ratio"
              name="captive"
          >
              <Input placeholder="" />
          </Form.Item>
          <Form.Item
              label="Driving Adjustment"
              name="driving"
          >
              <Input placeholder="" />
          </Form.Item>
      </Form>
      
      </div>
      <div className="d-flex align-items-center justify-content-end w-100 mt-4">
      <button  className="me-4 btn">
                  Cancel
              </button>
              <button  className="btn btn-primary">
                  Add
              </button>
      </div>
      </Drawer>
            {/* modal filter */}
            <Modal
                title="Filter"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null} // Remove default footer to use form's submit button
            >
                {renderModalContent()}
            </Modal>
            {/* end modal filter */}
    </div>

    
  );
};

export default Dashboard;
